module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image2_f9a17c53878369368835b802638e09bd.png";